import './AppHeader.css';

export function AppHeader() {
  return (
    <div className='AppHeader'>
      <h1>
        <div>
          <span className='magic-letter-check'>Check</span>
          <span className='magic-letter-it'>It</span>
        </div>
        <span className='magic-letter-app'>App</span>
      </h1>
      <p>Let's get your To-Dos done and organized!</p>
    </div>
  )
}